import toast from 'react-hot-toast';
import axios from "axios";
import { getUserData, invalidateSession } from "./Session";

const getApiErrorMessage = (error, fallback = "Terjadi kesalahan") => {
  const data = error?.response?.data;
  const details = data?.message?.details;

  if (typeof details === "string") return details;
  if (typeof data?.msg === "string") return data.msg;
  if (typeof data?.message === "string") return data.message;
  if (typeof data?.error === "string") return data.error;
  if (typeof error?.message === "string") return error.message;

  return fallback;
};

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3050/",
  headers: {
    "Content-Type": "application/json",
    ...(process.env.REACT_APP_API_KEY
      ? { "x-api-key": process.env.REACT_APP_API_KEY }
      : {}),
  },
});

API.interceptors.request.use((config) => {
  const token = getUserData()?.token;
  config.headers = config.headers || {};

  if (process.env.REACT_APP_API_KEY) {
    config.headers["x-api-key"] = process.env.REACT_APP_API_KEY;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = getApiErrorMessage(error, "Terjadi kesalahan komunikasi dengan server");

    if (status === 401 || status === 403) {
      invalidateSession();
      toast.error("Sesi telah berakhir. Silakan login kembali.", { duration: 3000 });
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    } else {
      toast.error(message, { duration: 4000 });
    }

    return Promise.reject(error);
  },
);

export default API;
export { getApiErrorMessage };
